module.exports = __webpack_public_path__ + "static/media/black-and-white-echo-park.92184b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/black-and-white-echo-park.jpg
// module id = 405
// module chunks = 0